export default "__VITE_ASSET__BRjsd3AU__"